var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarEmptyCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1706_4115)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1706_4115",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#C2C1C1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1706_4115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 0H0V100H100V0Z",
    fill: "#C2C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2502 51.6667C44.0705 51.6667 46.3636 49.3307 46.3636 46.4583C46.3636 43.586 44.0705 41.25 41.2502 41.25C38.43 41.25 36.1364 43.586 36.1364 46.4583C36.1364 49.3307 38.43 51.6667 41.2502 51.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3747 35H35.6248C32.5247 35 30 37.6298 30 40.8596V66.6404C30 69.8702 32.5247 72.5 35.6248 72.5H69.3747C72.4753 72.5 75 69.8702 75 66.6404V40.8596C75 37.6298 72.4753 35 69.3747 35ZM35.6248 39.6876H69.3747C69.996 39.6876 70.4999 40.2125 70.4999 40.8596V57.4978L63.3923 48.8585C62.6384 47.9376 61.547 47.4454 60.3749 47.4175C59.2094 47.4243 58.116 47.9633 57.3691 48.8963L49.0123 59.3444L46.2899 56.5154C44.7512 54.9126 42.2467 54.9126 40.71 56.5154L34.5001 62.9819V40.8596C34.5001 40.2125 35.004 39.6876 35.6248 39.6876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1248 27.5H50V31.25H31.4453C27.3047 31.25 26.25 33.75 26.25 36.25V55.4819V59.1404H22.5V33.3596C22.5 30.1298 25.0247 27.5 28.1248 27.5Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1706_4115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarEmptyCircle);
export default __webpack_public_path__ + "static/media/avatar-empty-circle.bf0e0060b88658f44702a387880807e6.svg";
export { ForwardRef as ReactComponent };